<template>
    <div>
        <van-nav-bar
        title="下载APP"
        @click-left="$router.push('/home')"
        left-arrow
        />
        <div class="contentBg">
            <div class="progress">
                <van-row type="flex" justify="center">
                    <van-col span="24">
                        <img
                        @click="showPopup('vueandrod')"
                        src="../assets/images/A-android.png"
                        width="45%"
                        />
                    </van-col>
                </van-row>

                <van-row type="flex" justify="center">
                    <van-col span="24">
                        <img
                        @click="showPopup('nativeapp_ios')"
                        src="../assets/images/A-apple.png"
                        width="45%"
                        />
                    </van-col>
                </van-row>
                <van-row type="flex" justify="center">
                    <van-col span="24">
                        <img
                        @click="showPopup('windows')"
                        src="../assets/images/Awindows.png"
                        width="45%"
                        />
                    </van-col>
                </van-row>
                <van-row type="flex" justify="center">
                    <van-col span="24">
                        <img
                        @click="showPopup('testflight')"
                        src="../assets/images/A-TFapple.png"
                        width="45%"
                        />
                    </van-col>
                </van-row>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "DownloadPage",
  components: {},
  data() {
    return {};
  },
  methods: {
    getAppDownloadLinks() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            action: "download_link"
          }
        })
        .then(function(res) {
          let resData = res.data;
          if (res.data.code === 1) {
            that.testFlightDownload = res.data.data.iOS_testflight;
            that.androidPro = res.data.data.android_pro;
            that.appleFreeUpgrade = res.data.data.apple_free_upgrade;
            that.androidFreeUpgrade = res.data.data.android_free_upgrade;
            that.nativeApp = res.data.data.app_app;
            that.pc_mac = res.data.data.pc_mac;
            that.pc_windows = res.data.data.pc_windows;
            that.hk_android = res.data.data.hk_android;
            that.hk_apple = res.data.data.hk_apple;
            that.hk_apple_tf = res.data.data.hk_apple_tf;
            // that.appDownloadImg = res.data.data.app_download_image;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(resData.msg);
          }
        });
    },
    showPopup(operate) {
      switch (operate) {
        case "testflight":
          this.qrPopup = true;
          this.popupContent = "苹果防闪退版";
          window.open(this.testFlightDownload);
          break;
        case "vueandrod":
          this.qrPopup = true;
          this.popupContent = "安卓专业版";
          window.open(this.androidPro);
          break;
        case "applefree":
          this.qrPopup = true;
          this.popupContent = "苹果免升级版";
          window.open(this.appleFreeUpgrade);
          break;
        case "androidfree":
          this.qrPopup = true;
          this.popupContent = "安卓免升级版";
          window.open(this.androidFreeUpgrade);
          break;
        case "nativeapp_android":
          this.qrPopup = true;
          this.popupContent = "安卓经典版";
          window.open(this.nativeApp);
          break;
        case "nativeapp_ios":
          this.qrPopup = true;
          this.popupContent = "苹果经典版";
          window.open(this.nativeApp);
          break;
        case "hkandroid":
          this.qrPopup = true;
          this.popupContent = "泓川港股安卓版";
          window.open(this.hk_android);
          break;
        case "hkapple":
          this.qrPopup = true;
          this.popupContent = "泓川港股苹果版";
          window.open(this.hk_apple);
          break;
        case "hkappletf":
          this.qrPopup = true;
          this.popupContent = "泓川港股苹果TF";
          window.open(this.hk_apple_tf);
          break;
        case "mac":
          this.qrPopup = false;
          this.popupContent = "MAC桌面端";
          window.open(this.pc_mac);
          break;
        case "windows":
          this.qrPopup = false;
          this.popupContent = "Windows桌面端";
          window.open(this.pc_windows);
          break;

        default:
          break;
      }
    }
  },
  mounted: function() {
    this.getAppDownloadLinks();
  }
};
</script>
<style scoped>
.contentBg {
  background: url("../assets/images/bg.png");
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  margin: 0px 0px 0px;
}

.progress {
  text-align: center;
  padding: 300px 0px 100px 0px; /* SET TOP AND BOTTOM  */
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadPage.vue